'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/home',
        name: 'home',
        meta: {
            title: 'Home',
        },
        component: () => view('home/index'),
    },
];
